document.addEventListener('DOMContentLoaded', function () {
  function smoothScrollToTarget(targetElement, headerHeight) {
    const adjustmentHeight = 20;
    if(headerHeight < 10) {
      headerHeight = 80
    }
    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: targetPosition - headerHeight - adjustmentHeight,
        behavior: 'smooth'
      });
    }
  }

  function handleAnchorClick(e, headerHeight) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    smoothScrollToTarget(targetElement, headerHeight);
  }

  window.addEventListener('load', function() {

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const headerHeight = document.querySelector('.js-site-header').offsetHeight;
        handleAnchorClick.call(this, e, headerHeight);
      });
    });

    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        const headerHeight = document.querySelector('.js-site-header').offsetHeight;
        smoothScrollToTarget(targetElement, headerHeight);
      }
    }
  });
});
